import { LoadButton, NoDataMessage, isNoData } from '../shared';
import { TitleCheckIcon } from '../icons';
import type { UseQueryResult } from '@tanstack/react-query';

interface TitleCheckTabProps {
  query: UseQueryResult<any>;
  loadEnabled: boolean;
  onLoad: () => void;
  disabled?: boolean;
}

export function TitleCheckTab({ query, loadEnabled, onLoad, disabled }: TitleCheckTabProps) {
  return (
    <div>
      {!loadEnabled && (
        <div className="flex flex-col items-center justify-center py-12">
          <TitleCheckIcon className="w-12 h-12 opacity-40 mb-4" />
          <p className="text-gray-400 text-sm mb-4">Check for salvage, flood, lemon, and odometer records</p>
          <LoadButton label="Check Title" onClick={onLoad} isLoading={false} isLoaded={false} disabled={disabled} />
        </div>
      )}

      {query.isLoading && (
        <p className="text-gray-500 text-sm text-center py-8">Checking title status...</p>
      )}

      {query.error && !isNoData(query) && (
        <p className="text-red-400 text-sm text-center py-4">Error checking title</p>
      )}

      {isNoData(query) && (
        <NoDataMessage message="No title records found for this vehicle" />
      )}

      {query.data?.data && !isNoData(query) && (
        <div className="space-y-4">
          <div className={`text-center p-6 rounded-xl ${query.data.data.salvage ? 'bg-red-500/20' : 'bg-green-500/20'}`}>
            <span className={`text-3xl font-bold ${query.data.data.salvage ? 'text-red-400' : 'text-green-400'}`}>
              {query.data.data.salvage ? 'Salvage Title' : 'Clean Title — No Salvage Record'}
            </span>
          </div>
          {query.data.data.salvage && query.data.data.salvage_details && (
            <div className="space-y-2">
              {query.data.data.salvage_details.map((detail: any, idx: number) => (
                <div key={idx} className="p-3 bg-red-500/10 rounded-lg">
                  <span className="text-white">Cause: {detail.cause}</span>
                  {detail.date && <span className="text-gray-400 ml-3">Date: {detail.date}</span>}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
